import React, { useEffect } from "react";
import { Flex, Box, Grid, GridItem } from "@chakra-ui/react";
import EducationBarCharts from "../components/EducationBarCharts";
import EducationPieCharts2 from "../components/EducationPieCharts2";
import { useDispatch, useSelector } from "react-redux";
import { fetchEducationDashboard } from "../redux/slices/dashboardSlice";
import img1 from "../Assets/Images/dcard-image-1.png";
import img2 from "../Assets/Images/dcard-image-2.png";
import img3 from "../Assets/Images/dcard-image-3.png";
import img4 from "../Assets/Images/dcard-image-4.png";
import img5 from "../Assets/Images/dcard-image-5.png";
import img6 from "../Assets/Images/dcard-image-6.png";
import img7 from "../Assets/Images/dcard-image-7.png";
import img8 from "../Assets/Images/dcard-image-8.png";
import DashboardDisplayCards from "../components/DashboardDisplayCards";

const EducationOMDashboard = () => {
  const dispatch = useDispatch();
  const educationDashboardData = useSelector(
    (state) => state?.dashboard?.educationDashboard
  );
  
  useEffect(() => {
    dispatch(fetchEducationDashboard());
  }, [dispatch]);

  const details = [
    {
      name: "Total Number Of Students",
      number: 150,
      bgcolor: "#FFF6EC",
      icon: img1,
      imgBgColor: "#FFE9BC",
    },
    {
      name: "Total Number Of NYSC Members",
      number: 250,
      bgcolor: "#FCEAE4",
      icon: img2,
      imgBgColor:"#F8D4C8"
    },
    {
      name: "Total Number Of Graduates",
      number: 90,
      bgcolor: "#EFE6F6",
      icon: img3,
      imgBgColor:"#E7D1F8"
    },
    {
      name: "Total Number Of Fellows",
      number: 20,
      bgcolor: "#FFECF0",
      icon: img1,
      imgBgColor:"#F4BCCA"
    },
    {
      name: "Total Number Of Associates",
      number: 20,
      bgcolor: "#EDF2FB",
      icon: img4,
      imgBgColor:"#416EFC4A"
    },
    
  ];
  
  const details2 = [
    {
      name: "Total Pending Application",
      number: 150,
      bgcolor: "#FFF6EC",
      icon: img5,
      imgBgColor: "#FFE9BC",
    },
    {
      name: "Total Approved Application",
      number: 250,
      bgcolor: "#EDF2FB",
      icon: img6,
      imgBgColor:"#416EFC4A"
    },
    {
      name: "Total Declined Application",
      number: 90,
      bgcolor: "#FFECF0",
      icon: img7,
      imgBgColor:"#F4BCCA"
    },
    {
      name: "Total Application in-progress",
      number: 250,
      bgcolor: "#EAFFF7",
      icon: img8,
      imgBgColor:"#8BB3AF"
    },
    
  ];

  return (
    <Flex
      flexDirection={"column"}
      gap={"20px"}
      py={"30px"}
      minH={"100vh"}
      px={3}
    >
      <Flex
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "flex-start"]}
        alignItems={"center"}
        gap={"20px"}
      >
        <Box w={["100%", "100%", "100%"]} bgColor={"#FFFFFF"} borderRadius={"14px"} border={"1px solid #E3EBEE"} padding={"20px"}>
          <Grid gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)","repeat(3, 1fr)","repeat(4, 1fr)", "repeat(5, 1fr)"]} gap={5}>
          {
            details?.map((detail, index) => (
              <GridItem>
                <DashboardDisplayCards key={index} {...detail} />
              </GridItem>
            ))
          }
          </Grid>
        </Box>
      </Flex>
      <Flex
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "flex-start"]}
        alignItems={"center"}
        gap={"20px"}
      >
        <Box w={["100%", "100%", "100%"]} bgColor={"#FFFFFF"} borderRadius={"14px"} border={"1px solid #E3EBEE"} padding={"20px"}>
          <Grid gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)","repeat(3, 1fr)","repeat(4, 1fr)",]} gap={5}>
          {
            details2?.map((detail, index) => (
              <GridItem>
                <DashboardDisplayCards key={index} {...detail} />
              </GridItem>
            ))
          }
          </Grid>
        </Box>
      </Flex>
      <Flex
        mt={6}
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "space-between"]}
        alignItems={"center"}
        gap={"20px"}
      >
        <Box w={["100%", "100%", "100%", "70%", "75%"]}>
          <EducationBarCharts
            barChartData={educationDashboardData?.totalApplicantPerMonth}
          />
        </Box>
        <Box w={["100%", "100%", "100%", "30%", "25%"]}>
          <EducationPieCharts2 />
        </Box>
      </Flex>
    </Flex>
  );
};

export default EducationOMDashboard;
